import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const DynamicWorkspaceRouteLazy = lazyWithRetry(() => import('./DynamicWorkspace'));
export function DynamicWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <DynamicWorkspaceRouteLazy />
    </Suspense>
  );
}
